#import "./PolicyDetailFields.graphql"

query GetPolicy($id: ID!) {
  policy(id: $id) {
    ...PolicyDetailFields
  }
}
